import { gql } from '@/__generated__';
import TeamMemberSection from './Info-section';
import TeamMemberButton from './member-button';
import { skipToken, useSuspenseQuery } from '@apollo/client';
import { useOrganizationContext } from '@/contexts/organization-context';
import { logError } from '@/lib/rum';
import { AvailableTeamMembersEnum } from '@/__generated__/graphql';
import SettingsTabTitle from '../settings-tab-title';

const OrganizationQuery = gql(`
  query TeamMembersSettingsQuery($input: OrganizationGetByIdInput!) {
    organization {
      getById(input: $input) {
        ... on OrganizationGetByIdSuccess {
          result {
            ...TeamMemberSectionFragment
            teamMembers {
              name
              ...TeamMemberButtonFragment
            }
          }
        }
      }
    }
  }
`);

export function TeamMembersTab() {
  const { organizationId } = useOrganizationContext();
  const { data, error } = useSuspenseQuery(
    OrganizationQuery,
    organizationId
      ? { variables: { input: { id: organizationId || '' } } }
      : skipToken
  );

  if (error || data?.organization?.getById?.__typename === 'NotFoundError') {
    logError(
      `Failed to get organization with organizationId ${organizationId}`,
      error
    );
    throw error;
  }

  if (!organizationId) {
    return (
      <div>
        <SettingsTabTitle title='Team Members' />
        <p>Please select an organization first.</p>
      </div>
    );
  }

  return (
    <>
      {data?.organization.getById.__typename ===
        'OrganizationGetByIdSuccess' && (
        <TeamMemberSection teamMembers={data?.organization?.getById?.result} />
      )}
      <div className='mt-4 flex justify-end gap-4'>
        {Object.values(AvailableTeamMembersEnum).map(
          (teamMemberEnum) =>
            data?.organization?.getById.__typename ===
              'OrganizationGetByIdSuccess' && (
              <TeamMemberButton
                key={teamMemberEnum}
                teamMember={data?.organization?.getById?.result?.teamMembers?.find(
                  (teamMember) => teamMember.name === teamMemberEnum
                )}
                name={teamMemberEnum}
              />
            )
        )}
      </div>
    </>
  );
}
